import {Offcanvas, OffcanvasGravity} from "../../offcanvas/Offcanvas";
import Rosetta from "../../../rosetta/Rosetta";
import {useEffect, useState} from "react";
import WindowUtil from "../../../util/WindowUtil";
import {CommonUtil} from "../../../util/CommonUtil";
import axios from "axios";
import {API, ENDPOINTS} from "../../../network/API";
import AlertModal from "../../alertmodal/AlertModal";
import {v4 as uuidv4} from "uuid";
import {LoadingSpinner} from "../../loading/LoadingSpinner";
import {Toast} from "../../toast/TokyoToaster";

export const ProjectContactEditorModal = (props) => {

    const {shown} = props;
    const {projectContactID} = props;
    const {projectID} = props;
    const {callback} = props;

    const [contact, setContact] = useState(null);
    const [networkInFlight, setNetworkInFlight] = useState(false);
    const [submitNetworkInFlight, setSubmitNetworkInFlight] = useState(false);

    const [name, setName] = useState("");
    const [data, setData] = useState({});

    const [phoneNumbers, setPhoneNumbers] = useState([]);
    const [emails, setEmails] = useState([]);

    const [forceDismiss, setForceDismiss] = useState(false);

    useEffect(() => {
        if (shown) {
            WindowUtil.lockBodyScroll();

            if (projectContactID) {
                fetchContactFromNetwork();
            }
        } else {
            WindowUtil.unlockBodyScroll();

            setContact(null);
            setNetworkInFlight(false);
            setName("");
            setData({});
            setPhoneNumbers([]);
            setEmails([]);
            setForceDismiss(false);
        }
    }, [shown]);

    useEffect(() => {
        if (shown && contact) {
            setName(CommonUtil.getOrDefault(contact, "name", ""));

            let contactData = CommonUtil.getOrDefault(contact, "data", null);
            if (contactData !== null) {
                if (!CommonUtil.isObject(contactData)) {
                    let dataParse = JSON.parse(contactData);
                    if (dataParse) {
                        contactData = dataParse;
                    } else {
                        contactData = null;
                    }
                }
            }

            if (contactData !== null) {
                setData(contactData);

                const phoneNumbers = CommonUtil.getOrDefault(contactData, "phoneNumbers", []);
                phoneNumbers.forEach((phoneNumber) => {
                    phoneNumber._localId = uuidv4();
                });
                setPhoneNumbers(phoneNumbers);

                const emails = CommonUtil.getOrDefault(contactData, "emails", []);
                emails.forEach((email) => {
                    email._localId = uuidv4();
                });
                setEmails(emails);
            }
        }
    }, [contact]);

    function setDataProperty(propertyName, value) {
        const newData = data ? CommonUtil.cloneObject(data) : {};
        newData[propertyName] = value;
        setData(newData);
    }

    function setPhoneNumberProperty(id, propertyName, value) {
        const newPhoneNumbers = [...phoneNumbers];

        for (let i = 0; i < newPhoneNumbers.length; i++) {
            if (newPhoneNumbers[i]._localId === id) {
                newPhoneNumbers[i][propertyName] = value;
                break;
            }
        }

        setPhoneNumbers(newPhoneNumbers);
    }

    function addPhoneNumber() {
        const newPhoneNumbers = [...phoneNumbers];

        newPhoneNumbers.push({
            _localId : uuidv4(),
            label : "",
            value : ""
        });

        setPhoneNumbers(newPhoneNumbers);
    }

    function removePhoneNumber(id) {
        const newPhoneNumbers = [...phoneNumbers];

        for (let i = 0; i < newPhoneNumbers.length; i++) {
            if (newPhoneNumbers[i]._localId === id) {
                newPhoneNumbers.splice(i, 1);
                break;
            }
        }

        setPhoneNumbers(newPhoneNumbers);
    }

    function addEmail() {
        const newEmails = [...emails];

        newEmails.push({
            _localId : uuidv4(),
            label : "",
            value : ""
        });

        setEmails(newEmails);
    }

    function setEmailProperty(id, propertyName, value) {
        const newEmails = [...emails];

        for (let i = 0; i < newEmails.length; i++) {
            if (newEmails[i]._localId === id) {
                newEmails[i][propertyName] = value;
                break;
            }
        }

        setEmails(newEmails);
    }

    function removeEmail(id) {
        const newEmails = [...emails];

        for (let i = 0; i < newEmails.length; i++) {
            if (newEmails[i]._localId === id) {
                newEmails.splice(i, 1);
                break;
            }
        }

        setEmails(newEmails);
    }

    function fetchContactFromNetwork() {
        if (!shown || networkInFlight) return;
        setNetworkInFlight(true);

        console.log("FETCH CONTACT", projectContactID);

        const data = {
            ids : [projectContactID],
            projectID
        };

        axios.post(ENDPOINTS.project.getProjectContacts, data)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    if (resp.data.data.length > 0) {
                        setContact(resp.data.data[0]);
                    } else {
                        AlertModal.showError(
                            Rosetta.string("common.error_not_found")
                        );
                        setForceDismiss(true);
                    }
                } else {
                    AlertModal.showError(API.formatError(resp));
                    setForceDismiss(true);
                }
                setNetworkInFlight(false);
            })
            .catch((e) => {
                console.log(e);
                setNetworkInFlight(false);
                AlertModal.showError(API.defaultError("PCF1000C"))
                setForceDismiss(true);
            });
    }

    function submitContactOverNetwork() {
        if (submitNetworkInFlight) return;

        if (!name || name.trim() === "") {
            AlertModal.showError(
                Rosetta.string("validation.missing_property", {
                    label : Rosetta.string("site_information.contact_editor_name")
                })
            );
            return;
        }

        setSubmitNetworkInFlight(true);

        const contactData = CommonUtil.cloneObject(data);

        contactData.phoneNumbers = [];
        phoneNumbers.forEach((number) => {
            let label = CommonUtil.getOrDefault(number, "label", "");
            let value = CommonUtil.getOrDefault(number, "value", "");

            if (label.trim() !== "" || value.trim() !== "") {
                contactData.phoneNumbers.push({
                    label,
                    value
                });
            }
        })

        contactData.emails = [];
        emails.forEach((email) => {
            let label = CommonUtil.getOrDefault(email, "label", "");
            let value = CommonUtil.getOrDefault(email, "value", "");

            if (label.trim() !== "" || value.trim() !== "") {
                contactData.emails.push({
                    label,
                    value
                });
            }
        });

        const formData = {
            projectID,
            name,
            data : JSON.stringify(contactData)
        };

        if (projectContactID) {
            formData.id = projectContactID;
        }

        axios.post(ENDPOINTS.project.submitProjectContact, formData)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    Toast.show(
                        Rosetta.string("common.success"),
                        Rosetta.string("site_information.contact_editor_submit_success"),
                        Toast.SUCCESS,
                        Toast.LONG
                    );

                    setForceDismiss(true);
                } else {
                    AlertModal.showError(API.formatError(resp));
                }
                setSubmitNetworkInFlight(false);
            })
            .catch((e) => {
                console.log(e);
                setSubmitNetworkInFlight(false);
                AlertModal.showError(API.defaultError("PCS1000C"));
            });
    }

    // RENDER

    if (!shown) return [];

    const mainContent = [];

    if (!networkInFlight) {
        // Name
        mainContent.push(
            <div className={"row"}>
                <div className={"col-12"}>
                    <label>{Rosetta.string("site_information.contact_editor_name")}</label>
                    <input
                        type={"text"}
                        name={"contact_editor_name"}
                        className={"form-control"}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>
            </div>
        );

        // Dynamic Data Fields - Simple text fields that can be inflated easily
        const dynamicFields = [
            {
                name : "company",
                label : Rosetta.string("site_information.contact_editor_company")
            },
            {
                name : "addressLine1",
                label : Rosetta.string("site_information.contact_editor_address_line_1")
            },
            {
                name : "addressLine2",
                label : Rosetta.string("site_information.contact_editor_address_line_2")
            },
            {
                name : "addressLine3",
                label : Rosetta.string("site_information.contact_editor_address_line_3")
            },
            {
                name : "addressCity",
                label : Rosetta.string("site_information.contact_editor_address_city")
            },
            {
                name : "addressCounty",
                label : Rosetta.string("site_information.contact_editor_address_county")
            },
            {
                name : "addressPostcode",
                label : Rosetta.string("site_information.contact_editor_address_postcode")
            }
        ]

        dynamicFields.forEach((field) => {
            mainContent.push(
                <div className={"row mt-2"}>
                    <div className={"col-12"}>
                        <label>{field.label}</label>
                        <input
                            type={"text"}
                            name={"contact_editor_" + field.name}
                            className={"form-control"}
                            value={CommonUtil.getOrDefault(data, field.name, "")}
                            onChange={(e) => {
                                setDataProperty(field.name, e.target.value)
                            }}
                        />
                    </div>
                </div>
            )
        });

        // Notes

        mainContent.push(
            <div className={"row mt-2"}>
                <div className={"col-12"}>
                    <label>{Rosetta.string("site_information.contact_editor_notes")}</label>
                    <textarea
                        className={"form-control"}
                        name={"contact_editor_notes"}
                        value={CommonUtil.getOrDefault(data, "notes", "")}
                        onChange={(e) => {
                            setDataProperty("notes", e.target.value)}
                        }
                    />
                </div>
            </div>
        )

        // Phone Numbers
        mainContent.push(
            <div className={"row mt-4"}>
                <div className={"col-12"}>
                    <div className={"d-flex align-items-center"}>
                        <h4>{Rosetta.string("site_information.contact_editor_phone_number")}</h4>
                        <div className={"flex-fill"} />
                        <button
                            className={"btn btn-primary"}
                            onClick={() => {
                                addPhoneNumber();
                            }}
                        >
                            {Rosetta.string("site_information.contact_editor_phone_add")}
                        </button>
                    </div>
                </div>
            </div>
        );

        if (phoneNumbers.length > 0) {
            phoneNumbers.forEach((phoneNumber, idx) => {
                mainContent.push(
                    <div className={"row mt-2"}>
                        <div className={"col-12"}>
                            <div className={"card"}>
                                <div className={"card-body"}>
                                    <div className={"row"}>
                                        <div className={"col-12"}>
                                            <label>{Rosetta.string("site_information.contact_editor_phone_label")}</label>
                                            <input
                                                type={"text"}
                                                className={"form-control"}
                                                value={CommonUtil.getOrDefault(phoneNumber, "label", "")}
                                                onChange={(e) => {
                                                    setPhoneNumberProperty(
                                                        phoneNumber._localId,
                                                        "label",
                                                        e.target.value
                                                    )
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className={"row mt-2"}>
                                        <div className={"col-12"}>
                                            <label>{Rosetta.string("site_information.contact_editor_phone_value")}</label>
                                            <input
                                                type={"text"}
                                                className={"form-control"}
                                                value={CommonUtil.getOrDefault(phoneNumber, "value", "")}
                                                onChange={(e) => {
                                                    setPhoneNumberProperty(
                                                        phoneNumber._localId,
                                                        "value",
                                                        e.target.value
                                                    )
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className={"card-footer justify-content-end"}>
                                    <button
                                        className={"btn btn-danger"}
                                        onClick={() => {
                                            removePhoneNumber(phoneNumber._localId);
                                        }}
                                    >
                                        {Rosetta.string("common.remove")}
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                )
            });
        } else {
            mainContent.push(
                <div className={"row mt-2"}>
                    <div className={"col-12 text-center"}>
                        <div className={"card"}>
                            <div className={"card-body"}>
                                <em>{Rosetta.string("site_information.contact_editor_phone_number_empty")}</em>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        // Emails
        mainContent.push(
            <div className={"row mt-4"}>
                <div className={"col-12"}>
                    <div className={"d-flex align-items-center"}>
                        <h4>{Rosetta.string("site_information.contact_editor_email")}</h4>
                        <div className={"flex-fill"} />
                        <button
                            className={"btn btn-primary"}
                            onClick={() => {
                                addEmail();
                            }}
                        >
                            {Rosetta.string("site_information.contact_editor_email_add")}
                        </button>
                    </div>
                </div>
            </div>
        );

        if (emails.length > 0) {
            emails.forEach((email, idx) => {
                mainContent.push(
                    <div className={"row mt-2"}>
                        <div className={"col-12"}>
                            <div className={"card"}>
                                <div className={"card-body"}>
                                    <div className={"row"}>
                                        <div className={"col-12"}>
                                            <label>{Rosetta.string("site_information.contact_editor_email_label")}</label>
                                            <input
                                                type={"text"}
                                                className={"form-control"}
                                                value={CommonUtil.getOrDefault(email, "label", "")}
                                                onChange={(e) => {
                                                    setEmailProperty(
                                                        email._localId,
                                                        "label",
                                                        e.target.value
                                                    )
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className={"row mt-2"}>
                                        <div className={"col-12"}>
                                            <label>{Rosetta.string("site_information.contact_editor_email_value")}</label>
                                            <input
                                                type={"text"}
                                                className={"form-control"}
                                                value={CommonUtil.getOrDefault(email, "value", "")}
                                                onChange={(e) => {
                                                    setEmailProperty(
                                                        email._localId,
                                                        "value",
                                                        e.target.value
                                                    )
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className={"card-footer justify-content-end"}>
                                    <button
                                        className={"btn btn-danger"}
                                        onClick={() => {
                                            removeEmail(email._localId);
                                        }}
                                    >
                                        {Rosetta.string("common.remove")}
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                )
            });
        } else {
            mainContent.push(
                <div className={"row mt-2"}>
                    <div className={"col-12 text-center"}>
                        <div className={"card"}>
                            <div className={"card-body"}>
                                <em>{Rosetta.string("site_information.contact_editor_email_empty")}</em>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        // Submit
        const submitButtonElem = [];
        if (!submitNetworkInFlight) {
            submitButtonElem.push(
                <button
                    className={"btn btn-success"}
                    onClick={() => submitContactOverNetwork()}
                >
                    {Rosetta.string("common.save")}
                </button>
            )
        } else {
            submitButtonElem.push(
                <button className={"btn btn-success disabled"}>
                    {Rosetta.string("common.save")}
                </button>
            )
        }

        mainContent.push(
            <div className={"row mt-4"}>
                <div className={"col-12 text-center"}>
                    {submitButtonElem}
                </div>
            </div>
        );
    } else {
        mainContent.push(
            <div className={"row mt-4"}>
                <div className={"col-12 text-center"}>
                    <LoadingSpinner inline={true} />
                </div>
            </div>
        );
    }

    return (
        <Offcanvas
            shown={true}
            title={Rosetta.string("site_information.contact_editor_title")}
            gravity={OffcanvasGravity.END}
            forceDismiss={forceDismiss}
            callback={callback}
        >

            {mainContent}

        </Offcanvas>
    )

}